import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { Field, formValueSelector } from 'redux-form';

import type { RootState } from 'af-reducers';

import { SegmentLabel } from '@acceligentllc/storybook';

import Checkbox from 'af-fields/Checkbox';

import DeliverablesSharedForm from 'af-components/SharedForms/Job/Details/Deliverables';

import WorkRequestUpsertFM from '../../formModel';
import { formSectionClass, formSectionClassRow } from '../../helpers';
import styles from '../../styles.module.scss';

type OwnProps = {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	change: (field: string, value: any) => void;
	formName: string;
};

type Props = OwnProps & ConnectedProps<typeof connector>;

const DeliverableSection: React.FC<Props> = (props) => {
	const { change, isDeliverable } = props;

	const onIsDeliverableClick = React.useCallback(() => {
		change(WorkRequestUpsertFM.getAttributeName('deliverableAssigneeId'), null);
		change(WorkRequestUpsertFM.getAttributeName('deliverableAssignee'), null);
		change(WorkRequestUpsertFM.getAttributeName('deliverableFileFormatId'), null);
		change(WorkRequestUpsertFM.getAttributeName('deliverableFileFormat'), null);
		change(WorkRequestUpsertFM.getAttributeName('deliverableSoftwareId'), null);
		change(WorkRequestUpsertFM.getAttributeName('deliverableSoftware'), null);
		change(WorkRequestUpsertFM.getAttributeName('deliverableCodeStandardId'), null);
		change(WorkRequestUpsertFM.getAttributeName('deliverableCodeStandard'), null);
		change(WorkRequestUpsertFM.getAttributeName('deliverableDeliveryTimelineId'), null);
		change(WorkRequestUpsertFM.getAttributeName('deliverableDeliveryTimeline'), null);
		change(WorkRequestUpsertFM.getAttributeName('deliverableDeliveryMethodId'), null);
		change(WorkRequestUpsertFM.getAttributeName('deliverableDeliveryMethod'), null);
		change(WorkRequestUpsertFM.getAttributeName('deliverableNotes'), null);
	}, [change]);

	return (
		<div className={formSectionClass}>
			<SegmentLabel
				label="Deliverables"
				tooltip="Specifications for what's delivered upon job completion — software, format, quality standards, and delivery method. Work orders created from a deliverable job populate the Deliverable table for further management."
			/>
			<div className={[formSectionClassRow, styles['work-request-form__deliverables']].join(' ')}>
				<Field
					component={Checkbox}
					id="isDeliverable"
					label="Is Deliverable"
					name={WorkRequestUpsertFM.getAttributeName('isDeliverable')}
					onValueChange={onIsDeliverableClick}
				/>
			</div>
			{isDeliverable &&
				<DeliverablesSharedForm />}
		</div>
	);
};

function mapStateToProps(state: RootState, props: OwnProps) {
	const { formName } = props;
	const selector = formValueSelector(formName);

	const isDeliverable = selector(
		state,
		WorkRequestUpsertFM.getAttributeName('isDeliverable')
	);

	return {
		isDeliverable,
	};
}

const connector = connect(mapStateToProps);

export default connector(DeliverableSection);
